import { useContext, useLayoutEffect, useState } from 'react';
import { OverlayContext } from '../../../providers/OverlayContextProvider';
// WHY: layout effect, and the rank outlives deactivation — claiming after paint renders one frame at the stack base, and dropping the rank on close would send the overlay behind its neighbours mid-exit-transition.
export function useOverlayZIndexOrder(active) {
    const { claimZIndexOrder, releaseZIndexOrder } = useContext(OverlayContext);
    const [zIndexOrder, setZIndexOrder] = useState();
    useLayoutEffect(()=>{
        if (!active) return undefined;
        setZIndexOrder(claimZIndexOrder());
        return releaseZIndexOrder;
    }, [
        active,
        claimZIndexOrder,
        releaseZIndexOrder
    ]);
    return zIndexOrder;
}
